module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/companies/company-logo-21-6140fcc570caaf2e0015a1055efd9dd4.png";